import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { BasicPageNoPadding } from '../../components/Layout/Layout.styles';
import { PlayFinderFilterTreeProvider } from './PlayFinderFilterTree/usePlayFinderFilterTreeContext';
import { PAGE } from '../../components/app/index.constants';

const PlayFinder = () => {
  const [pageInfo, setPageInfo] = useOutletContext();

  return (
    <BasicPageNoPadding $top={PAGE.DEFAULT.top}>
      <PlayFinderFilterTreeProvider>
        <Outlet context={[pageInfo, setPageInfo]} />
      </PlayFinderFilterTreeProvider>
    </BasicPageNoPadding>
  );
};

export default PlayFinder;
